import { Component, computed, inject, input, InputSignal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Product } from '../../../product/product.types';
import { Router, RouterLink } from '@angular/router';
import { ResolutionService } from '../../resolution.service';
import { SignalsStoreService } from '../../signals-store.service';

@Component({
  selector: 'app-after-bundle-added',
  imports: [RouterLink],
  templateUrl: './after-bundle-added.component.html',
  styleUrl: './after-bundle-added.component.scss'
})
export class AfterBundleAddedComponent {

  #activeModal = inject(NgbActiveModal);
  #resolutionService = inject(ResolutionService);
  #router = inject(Router);
  #signalsStoreService = inject(SignalsStoreService);

  product: InputSignal<Product> = input.required();
  isSubscription: InputSignal<boolean> = input.required();

  customBoxUrl = computed(() => this.#setUpCustomBoxUrl());
  isMobile = computed(() => this.#resolutionService.isMobile());

  closeModal() {
    this.#activeModal.close();
  }

  #setUpCustomBoxUrl() {
    const type = this.isSubscription() ? 'subscription' : 'common';
    return `shop/custom-box/${type}/${this.product().id}`
  }

  openCart() {
    if (this.isMobile())
      this.#router.navigate(['/order'])
    else
      this.#signalsStoreService.showCartPreview.set(true);

    this.closeModal();
  }
}
